import React, { useEffect, useState } from 'react';
import { Picker } from '@react-native-picker/picker';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from '../../store/hooks';
import { selectMenu, setSettings } from '../../store/slices/menuSlice';
import { onCreatePickerFolder, onDeletePickerFolder, onGetPickerOptions } from '../../shell/utils/appManagementFunctions';
import { PromptQuestionModal } from '../PromptQuestionModal';
import { store } from '../../store/store';
import { TrashButton } from './TrashButton';

interface PickerProps {
    onValueChanged: (value: string) => void;
}

export const TPicker: React.FC<PickerProps> = ({ onValueChanged }) => {
    const menuSlice = useAppSelector(selectMenu);
    const [showModal, setShowModal] = useState(false);

    const [selectedOption, setSelectedOption] = useState(menuSlice.settings.folder || 'default');
    const [pickerOptions, setPickerOptions] = useState<string[]>();
    const styles = StyleSheet.create({
        pickerContainer: {
            display: "flex",
            flexDirection: "row",
            alignSelf: "center",
            width: "100%",
            justifyContent: "center",
            marginTop: "2%",
        },
        picker: {
            // position: "absolute",
            // marginTop: "2%",
            // width: "40%",
            // alignSelf: "center"
            flexBasis: "40%"
        },
        trashStyle: {
            left: 30,
            bottom: 12,
        }
    });

    useEffect(() => {
        getAndSetPickerOptions();

    }, []);

    const getAndSetPickerOptions = () => {
        onGetPickerOptions().then(pickerOpts => {
            setPickerOptions(pickerOpts || []);
        });
    };

    const valueChanged = (itemValue: string) => {
        if (itemValue === 'add') {
            setShowModal(true);
            return;
        }
        setSelectedOption(itemValue);
        onValueChanged(itemValue);
    };
    const onDeleteClick = (approved: string | boolean) => {
        if (!approved) {
            return;
        }
        onDeletePickerFolder(selectedOption).then(res => {
            getAndSetPickerOptions();
        });
        valueChanged("default");

    };
    const onFolderSubmit = async (folder: string | boolean) => {
        if (!folder) {
            setShowModal(false);
            return;
        }
        if (typeof folder === 'string') {
            if (folder.toLocaleLowerCase() === 'default') {
                global.toast?.show('Choose a different name');
                return;
            }

            folder = `p_${folder}`;
            if (pickerOptions) {
                if (pickerOptions.find(picker => picker.toLocaleLowerCase() === folder.toString().toLocaleLowerCase())) {
                    global.toast?.show('Already exists');
                    return;

                }

                setPickerOptions([...pickerOptions, folder]);
            } else {
                setPickerOptions([folder]);

            }
            await onCreatePickerFolder(folder);
            store.dispatch(setSettings({ page: 0 }));
            setSelectedOption(folder);
            onValueChanged(folder);

        }
        setShowModal(false);

    };

    return (
        <View style={styles.pickerContainer}>
            <View style={styles.picker}>
                <Picker
                    selectedValue={`${selectedOption}`}
                    onValueChange={(itemValue: string, itemIndex: number) =>
                        valueChanged(itemValue)
                    }>
                    <Picker.Item label="Default" value="default" />
                    {pickerOptions?.map(option => (
                        <Picker.Item key={option} label={option.replace('p_', '')} value={`${option}`} />
                    ))}
                    <Picker.Item label="Add New Folder..." value="add" />
                </Picker>
            </View>
            <View style={styles.trashStyle}>
                {selectedOption !== 'default' ? <TrashButton modalProps={{ showCancel: true, hideInputField: true, title: "Are you sure you want to delete this folder?" }}
                    onClick={(approved) => onDeleteClick(approved)}>

                </TrashButton> : <></>}
            </View>
            {showModal ? <PromptQuestionModal showCancel={true} placeHolder={"Enter a new folder name..."} onSubmit={(input) => onFolderSubmit(input)}></PromptQuestionModal> : <></>}
        </View >
    );
};